import { render } from "./SubscriptionPlans.vue?vue&type=template&id=4b1617d1&scoped=true"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js"

import "./SubscriptionPlans.vue?vue&type=style&index=0&id=4b1617d1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1617d1"]])

export default __exports__